export enum EStorageKeys {
  ACCESSIBILITY_CONFIG_DATA = 'accessibilityConfigData',
  ADD_SUPPLIER = 'appSupplier',
  ASSIGNMENT_LIST_CUSTOM_COLUMNS = 'assignmentListCustomColumns',
  ASSIGNMENT_LIST_FILTER = 'assignmentListFilter',
  AUTH_TOKEN = 'authenticationToken',
  AUTH_TOKEN_EXPIRE = 'authTokenExpire',
  CLIENT_ID = 'clientId',
  CPSC_MAPPING_FILTER = 'cpscMappingFilter',
  CUSTOMIZED_SECTIONS = 'customizedSections',
  DRAFT_CHECKLIST = 'draftChecklistData',
  ENTITY_TYPE = 'entityType',
  GENERATE_BREAKDOWN_LIST_DIRECTION = 'generateBreakdownListDirection',
  LOCALE_LANGUAGE = 'localeLanguage',
  MATERIAL_CONFIG_DATA = 'materialConfigData',
  MENU_COLLAPSE = 'menuCollapse',
  ORDER_DETAIL_BACK = 'orderDetailBack',
  ORDER_INSTRUCTION_REMARK = 'orderInstructionRemark',
  PRODUCT_CATEGORIES = 'productCategories',
  PRODUCT_TREE = 'productTree',
  REFRESH_TOKEN = 'refreshToken',
  REFRESH_TOKEN_EXPIRE = 'refreshTokenExpire',
  REPORT_GENERATION_FILTER = 'reportGenerationFilter',
  REPORT_GENERATION_ORDER_CUSTOM_COLUMNS = 'reportGenerationOrderCustomColumns',
  REPORT_GENERATION_ORDER_FILTER = 'reportGenerationOrderFilter',
  REPORT_GENERATION_REPORT_CUSTOM_COLUMNS = 'reportGenerationReportCustomColumns',
  REPORT_GENERATION_REPORT_FILTER = 'reportGenerationReportFilter',
  SCAN_FONTSIZE = 'scanFontSize',
  SESSION_ID = 'sessionId',
  SIDE_MENU_COLLAPSED_IDS = 'side-menu-collapsed-ids',
  SIDE_MENU_FILTER_DATA = 'side-menu-filter-data',
  TEMPLATE_LIST_FILTER = 'templateListFilter',
  TEST_LIST_FILTER = 'testListFilter',
  TEST_LIST_FILTER_FOR_LIST = 'testListFilterForList',
  USER_DATA = 'userData',
  USER_ID = 'userId',
  USER_PERMISSIONS = 'userPermissions',
}
